// extracted by mini-css-extract-plugin
export default {"focusable":"styles_focusable__UuoKa","link":"styles_link__6kO-8","spatialActive":"styles_spatialActive__Kv2QZ","active":"styles_active__WysMm"};